import React, { useRef } from "react";

import clsx from "clsx";
import { useModal } from "../../hooks/useModal";
import { ModalLocation } from "../../types/modalLocation";
import { useVideoPlayerRefs } from "../../contexts/VideoPlayerRefs";
import { createPortal } from "react-dom";
import { useRoot } from "../../contexts/Root";

import styles from "./styles.module.css";

interface Props {
  closeSelf: () => void;
  modalLocation: ModalLocation;
  children: React.ReactNode;
  width?: number;
  show: boolean;
}

export const Modal = ({
  show,
  closeSelf,
  children,
  modalLocation,
  width,
}: Props) => {
  const { container } = useVideoPlayerRefs();
  const {
    theme: { foreground, primaryBackground },
  } = useRoot();
  const ref = useRef<HTMLDivElement>(null);
  useModal(show, closeSelf, ref);

  const style = {
    width,
    color: foreground,
    background: primaryBackground,
  };

  const containerClass = clsx(
    styles.container,
    modalLocation === ModalLocation.bottomRight
      ? styles.bottomRight
      : styles.topRight,
    !show && styles.slideRight
  );

  return (
    container.current !== null &&
    createPortal(
      <div ref={ref} style={style} className={containerClass}>
        {children}
      </div>,
      container.current
    )
  );
};
